/*
 * @Description: 
 * @Author: code-shan
 * @Date: 2023-05-09 11:49:12
 * @LastEditTime: 2023-08-17 10:34:29
 * @LastEditors: code-shan
 * @FilePath: \e-taxi\src\config\app.config.js
 */

export default {
    // app_tag:"5a1d9851", //test
    // app_tag: "230f43f3", //prod
    app_tag: process.env.EVN_CONFIG !== 'prod' ? "5a1d9851" : "230f43f3",
}


// WEBPACK FOOTER //
// ./src/config/app.config.js